import { useState, useCallback } from 'react';
import { message } from 'antd';
import { sendEmailWithAttachment } from '../../../api/planDocumentsApi';
import { getCurrentUserId } from '../../../utils/userUtils';

export const useEmailDocument = () => {
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const [selectedEmailDocument, setSelectedEmailDocument] = useState(null);
  const [recipientEmail, setRecipientEmail] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [sending, setSending] = useState(false);
  const [emailSubject, setEmailSubject] = useState('');
  const [emailMessage, setEmailMessage] = useState('');

  const handleEmailDocument = useCallback((document) => {
    setSelectedEmailDocument(document);
    setIsEmailModalVisible(true);
  }, []);

  const handleEmailModalCancel = useCallback(() => {
    setIsEmailModalVisible(false);
    setSelectedEmailDocument(null);
    setRecipientEmail('');
    setRecipientName('');
    setEmailSubject('');
    setEmailMessage('');
  }, []);

  const handleSendEmail = useCallback(async () => {
    if (!recipientEmail || !recipientName || !emailSubject || !emailMessage) {
      message.error('Please fill in all required fields');
      return;
    }

    setSending(true);
    try {
      const userId = getCurrentUserId();
      const result = await sendEmailWithAttachment(
        userId,
        recipientName,
        recipientEmail,
        emailSubject,
        emailMessage,
        selectedEmailDocument.name
      );

      console.log('Email sent successfully:', result);
      message.success('Email sent successfully');
      handleEmailModalCancel();
    } catch (error) {
      console.error('Error sending email:', error);
      message.error(
        error.response?.data?.detail || 
        error.message || 
        'Failed to send email. Please try again.'
      );
    } finally {
      setSending(false);
    }
  }, [recipientEmail, recipientName, emailSubject, emailMessage, selectedEmailDocument, handleEmailModalCancel]);

  return {
    isEmailModalVisible,
    selectedEmailDocument,
    recipientEmail,
    setRecipientEmail,
    recipientName,
    setRecipientName,
    emailSubject,
    setEmailSubject,
    emailMessage,
    setEmailMessage,
    sending,
    handleEmailDocument,
    handleEmailModalCancel,
    handleSendEmail,
  };
};